module.exports = __webpack_public_path__ + "static/media/price_changed.22c3424b.png";